import {
    DEFAULT_IMPORT_TARGET_DPI,
    IMPORT_BASELINE_DPI,
    DesignFileAnalysis,
    DesignFileAnalysisElement,
    ImportTargetDpi,
} from './types';

const INDESIGN_EXTENSIONS = new Set(['idml', 'zip']);

const normalizeExtension = (extension?: string) => extension?.replace(/^\./, '').toLowerCase() || '';

export { DEFAULT_IMPORT_TARGET_DPI, IMPORT_BASELINE_DPI } from './types';

export const getNormalizedDesignFileExtension = (analysis?: DesignFileAnalysis) => {
    if (!analysis) {
        return '';
    }

    if ('extensions' in analysis) {
        return normalizeExtension(analysis.extensions?.[0]);
    }

    return normalizeExtension(analysis.extension);
};

export const isIndesignDesignFileAnalysis = (analysis?: DesignFileAnalysis) =>
    INDESIGN_EXTENSIONS.has(getNormalizedDesignFileExtension(analysis));

export const getScaledArtboardDimensions = (
    artboard: { width: number; height: number },
    targetDpi: ImportTargetDpi = DEFAULT_IMPORT_TARGET_DPI,
) => ({
    width: Math.round((artboard.width * targetDpi) / IMPORT_BASELINE_DPI),
    height: Math.round((artboard.height * targetDpi) / IMPORT_BASELINE_DPI),
});

export const isScaledArtboardOverMaxSize = (
    artboard: { width: number; height: number },
    targetDpi: ImportTargetDpi,
    maxSize: number,
) => {
    const { width, height } = getScaledArtboardDimensions(artboard, targetDpi);

    return width > maxSize || height > maxSize;
};

export const artboardExceedsTextLimit = (artboard: { elements?: DesignFileAnalysisElement[] }, maxCharacters: number) =>
    Boolean(
        artboard?.elements?.some(
            (element) => typeof element?.characterCount === 'number' && element.characterCount > maxCharacters,
        ),
    );
